module.exports = __webpack_public_path__ + "img/ty_4.56073937.png";